import { FC } from "react"
import { FaFolderOpen, FaPlus, FaSave } from "react-icons/fa"

import { RulePreset } from "types/tournament.types"

interface PointRulesToolbarProps {
  presets: RulePreset[]
  hasRules: boolean
  onAddRule: () => void
  onLoadPreset: (preset: RulePreset) => void
  onSavePreset: () => void
}

export const PointRulesToolbar: FC<PointRulesToolbarProps> = ({ presets, hasRules, onAddRule, onLoadPreset, onSavePreset }) => (
  <div className="flex items-center justify-between flex-wrap gap-2">
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Point Rules</label>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Configure scoring rules for points-based tournaments</p>
    </div>
    <div className="flex gap-2">
      {/* Load Preset */}
      {presets.length > 0 && (
        <div className="relative group">
          <button
            type="button"
            className="flex items-center gap-2 px-3 py-1 text-sm border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
          >
            <FaFolderOpen /> Load Preset
          </button>
          <div className="absolute right-0 top-full mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-10 min-w-[220px] hidden group-hover:block">
            {presets.map((p) => (
              <button
                key={p.id}
                type="button"
                onClick={() => onLoadPreset(p)}
                className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300"
              >
                <div className="font-medium">{p.name}</div>
                {p.description && <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{p.description}</div>}
                <div className="text-xs text-gray-400 dark:text-gray-500">{p.rules?.length || 0} rules</div>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Save as Preset */}
      {hasRules && (
        <button
          type="button"
          onClick={onSavePreset}
          className="flex items-center gap-2 px-3 py-1 text-sm border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-50 dark:hover:bg-gray-800"
        >
          <FaSave /> Save Preset
        </button>
      )}

      {/* Add Rule */}
      <button
        type="button"
        onClick={onAddRule}
        className="flex items-center gap-2 px-3 py-1 text-sm bg-[rgba(169,78,206,1)] text-white rounded hover:bg-[rgba(169,78,206,0.8)]"
      >
        <FaPlus /> Add Rule
      </button>
    </div>
  </div>
)
